var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTajikistan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19072 6.78262C0.427875 8.36025 0 10.1302 0 12C0 13.8698 0.427875 15.6397 1.19072 17.2174L12 18.2609L22.8093 17.2174C23.5721 15.6397 24 13.8698 24 12C24 10.1302 23.5721 8.36025 22.8093 6.78262L12 5.73914L1.19072 6.78262Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19116 17.2174C3.13212 21.2313 7.24254 24 12 24C16.7575 24 20.868 21.2313 22.8089 17.2174H1.19116Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19116 6.78263H22.8089C20.868 2.76872 16.7575 0 12 0C7.24254 0 3.13212 2.76872 1.19116 6.78263Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91302 15.1305H14.087V13.3565L13.2522 13.7739L12 12.5217L10.7478 13.7739L9.91302 13.3565V15.1305Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52492 13.0435L7.71921 13.6413H8.34781L7.83921 14.0108L8.03351 14.6087L7.52492 14.2392L7.01632 14.6087L7.21062 14.0108L6.70203 13.6413H7.33062L7.52492 13.0435Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12721 10.9565L8.32151 11.5544H8.9501L8.44151 11.9239L8.63576 12.5217L8.12721 12.1522L7.61862 12.5217L7.81291 11.9239L7.30432 11.5544H7.93291L8.12721 10.9565Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84901 9.39133L10.0433 9.98917H10.6719L10.1634 10.3587L10.3576 10.9565L9.84901 10.5871L9.34047 10.9565L9.53472 10.3587L9.02612 9.98917H9.65476L9.84901 9.39133Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4751 13.0435L16.2808 13.6413H15.6522L16.1608 14.0108L15.9665 14.6087L16.4751 14.2392L16.9836 14.6087L16.7893 14.0108L17.2979 13.6413H16.6693L16.4751 13.0435Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8728 10.9565L15.6785 11.5544H15.0499L15.5585 11.9239L15.3642 12.5217L15.8728 12.1522L16.3814 12.5217L16.1871 11.9239L16.6956 11.5544H16.0671L15.8728 10.9565Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1509 9.39133L13.9566 9.98917H13.3281L13.8366 10.3587L13.6423 10.9565L14.1509 10.5871L14.6595 10.9565L14.4652 10.3587L14.9738 9.98917H14.3452L14.1509 9.39133Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.60864L12.1942 9.20649H12.8228L12.3142 9.576L12.5085 10.1738L12 9.80438L11.4914 10.1738L11.6857 9.576L11.1771 9.20649H11.8057L12 8.60864Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTajikistan);
export default __webpack_public_path__ + "static/media/tajikistan.eb9d39965bca618e5af72ce155936f10.svg";
export { ForwardRef as ReactComponent };